module.exports = __webpack_public_path__ + "static/media/chooseSeats.svg";